import { useFeatureToggleFilters } from './useFeatureToggleFilters';
import { Filters } from './filters';
import { useFilters } from './filtersContext/filtersContext';

export const useEnabledFilters = () => {
  const { filters } = useFilters();
  const featureToggleFilters = useFeatureToggleFilters();

  const enabledFilters: Filters = (Object.keys(filters) as Array<keyof Filters>).reduce(
    (features, filterKey) => ({
      ...features,
      ...(featureToggleFilters[filterKey] ? { [filterKey]: filters[filterKey] } : {}),
    }),
    {}
  );

  return {
    enabledFilters,
    numberOfEnabledFiltersApplied: Object.keys(enabledFilters).length,
  };
};
